module.exports = __webpack_public_path__ + "static/it_strategy_development_process-42bf2a4bccbc83d2f56fc27263e7e7a0.jpg";